import { Check, Users } from 'lucide-react';

interface Props {
  participants: { email: string; name: string | null }[];
  selected: Set<string>;
  onToggle: (email: string) => void;
}

/** Altri indirizzi dello stesso dominio, da creare come referenti della stessa azienda. */
export function ThreadParticipantsPicker({ participants, selected, onToggle }: Props) {
  if (participants.length === 0) return null;

  return (
    <div className="space-y-2 mail-link-section">
      <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-wide font-semibold text-[#787774] dark:text-white/50">
        <Users className="h-3 w-3" />
        Altre persone in questa conversazione
      </div>

      <div className="space-y-0.5">
        {participants.map((p, i) => {
          const isOn = selected.has(p.email);
          return (
            <button
              key={p.email}
              type="button"
              onClick={() => onToggle(p.email)}
              style={{ animationDelay: `${Math.min(i, 8) * 20}ms` }}
              className={`mail-link-row w-full flex items-center gap-2.5 px-2 py-1.5 rounded-lg text-left transition-colors duration-100 ${
                isOn ? 'bg-[rgba(35,131,226,0.07)]' : 'hover:bg-[rgba(55,53,47,0.04)] dark:hover:bg-white/[0.05]'
              }`}
            >
              <span
                className={`flex-shrink-0 w-4 h-4 rounded flex items-center justify-center border transition-all duration-150 ${
                  isOn
                    ? 'bg-[#2383E2] border-[#2383E2] text-white'
                    : 'border-[rgba(55,53,47,0.25)] dark:border-white/25'
                }`}
              >
                {isOn && <Check className="h-3 w-3" />}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm text-[#37352F] dark:text-white truncate">{p.name || p.email}</span>
                {p.name && <span className="block text-xs text-[#787774] dark:text-white/40 truncate">{p.email}</span>}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
